import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import type { NodeSpec } from './NodeSpec';

export const logOutOperatorUiNodeSpec: NodeSpec<NodeCfg<'logOutOperator'>> = {
    cfg: () => ({ id: getUID(), kind: 'logOutOperator', width: 210 }),
    controls: () => ({}),
    inputs: () => ({
        trigger: { socket: 'event', label: 'Trigger' },
    }),
    kindLabel: 'Log Out Active Operator',
    nodeCategory: 'events',
    outputs: () => ({
        next: { socket: 'event', label: 'Next' },
    }),
    requiredSockets: [ 'trigger' ],
    validator: () => true,
};
